import { baseUrl, environment } from "../environment";
import {
  AddDesignationPayload,
  AddEmployeeTimingPayload,
  DepartmentAddPayload,
  DepartmentAllPayload,
  EmployeeTimingListPayload,
  DesignationtAllPayload,
  OrganizationAddPayload,
  OrganizationGetAllPayload,
  ServiceOfferPayload,
  AddEmployeeTypePayload,
  EmployeeTypeListPayload,
  DepartmentEditPayload,
  DesignationEditPayload,
  EmployeeTypeEditPayload,
  EmployeeTimingEditPayload,
  DepartmentDeletePayload,
  DesignationDeletePayload,
  OrganizationEditPayload,
  EmployeeTimingDeletePayload,
  EmployeeTypeDeletePayload,
  DomainPayload,
  AddSalaryStructurePayload,
  SalaryStructureList,
  SalaryStructureListPayload,
  SalaryStructureComponentPayload,
  SalaryStructureGetByIDPayload,
  AddPostPayload,
  AddSalaryComponentPayload,
  DeleteSalaryComponentPayload,
  SalaryComponentEditPayload,
  PostDeletePayload,
  EditPostPayload,
  MainDashboardPayload,
  SyncEmpPayload,
  SalaryComponentThresholdPayload,
  recentAnnouncements,
  AnnouncemnetDeletePayload,
  CreateOrUpdatePostPayload,
  CommentOnAPostPayload,
  GetAllCommentOnAPostPayload,
  LikeAPostPayload,
  UpdateShiftPayload,
} from "../models/organizationModels";
import RestService from "./rest";

export const serviceClient = new RestService({
  baseURL: baseUrl,
});

export const OrganizationAddService = (data: OrganizationAddPayload) => {
  return serviceClient.post(environment.urls.createOrganization, data);
};

export const GetOrganizationReportColumnsService = (
  organization_id: number | string
) => {
  return serviceClient.get(
    `${environment.urls.getOrganizationReportColumns}/${organization_id}`
  );
};

export const DepartmentAddService = (data: DepartmentAddPayload) => {
  return serviceClient.post(environment.urls.createDepartment, data);
};

export const GetAllOrganizationService = (data?: OrganizationGetAllPayload) => {
  return serviceClient.get(environment.urls.getAllOrganization, {
    params: {
      page: data?.page ?? 1,
      limit: data?.limit ?? 10,
      ...(data?.q ? { q: data.q } : {}),
      ...(data?.organization_id
        ? { organization_id: data.organization_id }
        : {}),
    },
  });
};
export const GetAllDepartmentService = (data: DepartmentAllPayload) => {
  return serviceClient.post(environment.urls.getAllDepartment, data);
};
export const GetAllServiceOfferdService = () => {
  return serviceClient.get(environment.urls.getAllServices);
};
export const EmployeeTimingAddService = (data: AddEmployeeTimingPayload) => {
  return serviceClient.post(environment.urls.createEmployeeTiming, data);
};
export const EmployeeDesignationAddService = (data: AddDesignationPayload) => {
  return serviceClient.post(environment.urls.createEmployeeDesignation, data);
};
export const GetAllDesignationService = (data: DesignationtAllPayload) => {
  return serviceClient.post(environment.urls.getAllDesignation, data);
};
export const GetAllEmployeeTimimgService = (
  data: EmployeeTimingListPayload
) => {
  return serviceClient.post(environment.urls.getAllEmployeeTimingList, data);
};
export const EmployeeTypeAddService = (data: AddEmployeeTypePayload) => {
  return serviceClient.post(environment.urls.createEmployeeType, data);
};
export const OrganizationEditService = (data: OrganizationEditPayload) => {
  return serviceClient.post(environment.urls.editOrganizationList, data);
};
export const GetAllEmployeeTypeService = (data: EmployeeTypeListPayload) => {
  return serviceClient.post(environment.urls.getAllEmployeeTypeList, data);
};
export const DepartmentEditService = (data: DepartmentEditPayload) => {
  return serviceClient.post(environment.urls.editDepartmentList, data);
};
export const DesignationEditService = (data: DesignationEditPayload) => {
  return serviceClient.post(environment.urls.editDesignationList, data);
};
export const EmployeeTypeEditService = (data: EmployeeTypeEditPayload) => {
  return serviceClient.post(environment.urls.editEmployeeTypeList, data);
};
export const EmployeeTimingEditService = (data: EmployeeTimingEditPayload) => {
  return serviceClient.post(environment.urls.editEmployeeTimingList, data);
};
export const DepartmentDeleteService = (data: DepartmentDeletePayload) => {
  return serviceClient.post(environment.urls.DeleteDepertment, data);
};
export const DesignationDeleteService = (data: DesignationDeletePayload) => {
  return serviceClient.post(environment.urls.DeleteDesignation, data);
};
export const EmployeeTypeDeleteService = (data: EmployeeTypeDeletePayload) => {
  return serviceClient.post(environment.urls.DeleteEmployeeType, data);
};
export const EmployeeTimingDeleteService = (
  data: EmployeeTimingDeletePayload
) => {
  return serviceClient.post(environment.urls.DeleteEmployeeTiming, data);
};
export const DomainGetAllService = (data: DomainPayload) => {
  return serviceClient.post(environment.urls.AllDomainType, data);
};
export const GetAllDomainListService = () => {
  return serviceClient.get(environment.urls.getSalaryStructure);
};
export const AddSalaryStructureService = (data: AddSalaryStructurePayload) => {
  return serviceClient.post(environment.urls.AddSalaryStructure, data);
};
export const GetAllSalaryStructureService = (
  data: SalaryStructureListPayload
) => {
  return serviceClient.post(environment.urls.GetAllSalaryStructureList, data);
};
export const GetByIDListService = (data: SalaryStructureGetByIDPayload) => {
  return serviceClient.post(environment.urls.GetSalaryStructureByID, data);
};

//announcement
export const CreateAnnouncementService = (data: recentAnnouncements) => {
  return serviceClient.post(environment.urls.createAnnouncement, data);
};
export const getAllAnnouncementService = () => {
  return serviceClient.get(environment.urls.getAllAnnouncement);
};
export const AnnouncementDeleteService = (data: AnnouncemnetDeletePayload) => {
  return serviceClient.post(environment.urls.deleteAnnouncement, data);
};

// POST
export const PostAddService = (data: AddPostPayload) => {
  return serviceClient.post(environment.urls.AddPost, data);
};

export const SalaryComponentGetAll = () => {
  return serviceClient.get(environment.urls.SalarycomponentGetAllurl);
};
export const SalaryComponentAddService = (data: AddSalaryComponentPayload) => {
  return serviceClient.post(environment.urls.AddSalaryComponent, data);
};
export const GetAllPostService = () => {
  return serviceClient.get(environment.urls.getAllPost);
};
export const SalaryComponentDeleteService = (
  data: DeleteSalaryComponentPayload
) => {
  return serviceClient.post(environment.urls.DeleteSalaryComponent, data);
};
export const SalaryComponentEditService = (
  data: SalaryComponentEditPayload
) => {
  return serviceClient.post(environment.urls.editSalaryComponent, data);
};
export const PostDeleteService = (data: PostDeletePayload) => {
  return serviceClient.post(environment.urls.deletePost, data);
};
export const PostEditService = (data: EditPostPayload) => {
  return serviceClient.post(environment.urls.editPost, data);
};
export const SalaryStructureUpdate = (data: any) => {
  return serviceClient.post(environment.urls.SalaryStructureUpdate, data);
};
export const SampleSalaryDownload = (data: any) => {
  return serviceClient.post(environment.urls.sampleSalarydownload, data);
};
export const GetMainDashBoardService = (data: MainDashboardPayload) => {
  return serviceClient.post(environment.urls.getMainDashboard, data);
};
export const SyncAllEmpService = (data: SyncEmpPayload) => {
  return serviceClient.post(environment.urls.syncSalaryStructureForEmp, data);
};
export const SalaryComponentThresholdService = (
  data: SalaryComponentThresholdPayload
) => {
  return serviceClient.post(environment.urls.thresholdParameter, data);
};
// Get All Post List
export const GetAllPostListService = () => {
  return serviceClient.get(environment.urls.getAllPostList);
};
// Create or Update Post
export const CreateOrUpdatePostService = (
  payload: CreateOrUpdatePostPayload
) => {
  return serviceClient.post(environment.urls.createUpdatePost, payload);
};
// Comment On A Post
export const CommentOnAPostService = (payload: CommentOnAPostPayload) => {
  return serviceClient.post(environment.urls.commentOnPost, payload);
};
// Get all Comment On A Post
export const GetAllCommentOnAPostService = (
  payload: GetAllCommentOnAPostPayload
) => {
  return serviceClient.post(environment.urls.getAllCommentOnPost, payload);
};
// Like A Post
export const LikeAPostService = (payload: LikeAPostPayload) => {
  return serviceClient.post(environment.urls.likePost, payload);
};

//Update Shift
export const UpdateEmployeeShiftService = (data: UpdateShiftPayload) => {
  return serviceClient.post(environment.urls.updateEmployeeShift, data);
};

// Organogram
export const getOrganogramService = (data: any) => {
  return serviceClient.post(environment.urls.getOrganogram, data);
};

// Organization Chart (parent-child organogram)
export const getOrgChartService = (data: { organization_id: number }) => {
  return serviceClient.post(environment.urls.getOrgChart, data);
};

// Organization Bulk Upload Services
export const GetOrgBulkStatusService = (
  type: string = "all",
  excelType?: string | number,
  page_index?: number,
  page_size?: number
) => {
  const excelParam =
    excelType !== undefined && excelType !== "" && excelType !== null
      ? `&excel_type=${excelType}`
      : "";
  
  // Map page_index (0-indexed) to page (1-indexed)
  const page = page_index !== undefined ? page_index + 1 : undefined;

  const pagingParam =
    page !== undefined && page_size !== undefined
      ? `&page=${page}&limit=${page_size}`
      : "";
  return serviceClient.get(
    `${environment.urls.getOrgBulkStatus}?type=${type}${excelParam}${pagingParam}`
  );
};

export const GetOrgBulkStatusByIdService = (uploadId: number) => {
  return serviceClient.get(`${environment.urls.getOrgBulkStatusById}${uploadId}`);
};

export const DownloadOrgBulkTemplateService = (type: string) => {
  return serviceClient.get(`${environment.urls.downloadOrgBulkTemplate}?type=${type}`, {
    responseType: "blob",
  });
};

export const DownloadOrgBulkFileService = (uploadId: number | string) => {
  return serviceClient.get(`${environment.urls.downloadOrgBulkFile}${uploadId}`, {
    responseType: "blob",
  });
};

export const UploadOrgBulkService = (formData: FormData) => {
  return serviceClient.postWithConfig(
    environment.urls.uploadOrgBulk,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

